import { useEffect, useState } from 'react';
/**
 * Подписка на обзервабл
 */
export function useObservable(obs$, setState) {
    useEffect(function () {
        var sub = obs$.subscribe(function (state) {
            setState(state);
        });
        return function () {
            sub.unsubscribe();
        };
    }, [obs$, setState]);
}
/**
 * Подписка на обзервабл с локальным стейтом
 */
export function useObservableState(obs$, initialState) {
    if (initialState === void 0) { initialState = null; }
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    useObservable(obs$, setState);
    return state;
}
/**
 * Подписка на BehaviorSubject
 */
export function useSubject(sub$) {
    return useObservableState(sub$, sub$.value);
}
//# sourceMappingURL=useObservable.js.map